import axios from "axios";
import { useContext, useState } from "react";
import { useHistory } from "react-router-dom";
import { store } from "../../Helper/Context/Store";
import "./HomeLocation.css";
import PlaceSearch from "./PlaceSearch";
import useGeoLocation from "./UseGeoLocation";
import UserAddresses from "./UserAddresses";
export default function HomeLocation(props) {
  const location = useGeoLocation();
  let history = useHistory();
  let api_key = "AIzaSyA4UpIpBjkSzH8T280zKffdTVdnt170Ke4";
  const {
    setLat,
    setLang,
    setmapPostitionMarkerLat,
    setmapPostitionMarkerLang,
    setMapAddress,
    selectedPincode
  } = useContext(store);
  const [detectedPincode, setDetectedPincode] = useState(null)
  const showMyLocation = async () => {
    if (location.loaded && !location.error) {
      setLat(location.coordinates.lat);
      setLang(location.coordinates.lng);
      axios
        .get(
          "https://maps.googleapis.com/maps/api/geocode/json?latlng=" +
          location.coordinates.lat +
          "," +
          location.coordinates.lng +
          `&key=${api_key}`
        )
        .then((res) => {
          const pincode = res.data.results[0].address_components.filter((code) => code.types == 'postal_code')[0]?.long_name;
          setDetectedPincode(pincode);
          // if (pincode === selectedPincode) {

          setmapPostitionMarkerLat(res.data.results[0].geometry.location.lat);
          setmapPostitionMarkerLang(res.data.results[0].geometry.location.lng);
          setMapAddress(
            res.data.results.filter((obj) =>
              obj.types.includes("sublocality")
            )[0]?.formatted_address
          );
          sessionStorage.setItem(
            "Curr_Loc",
            JSON.stringify(res.data.results[0].address_components)
          );
          sessionStorage.setItem(
            "Form_Add",
            JSON.stringify(res.data.results[0].formatted_address)
          );
          // }
        });
    } else {
      console.log("error");
      // alert(location.error.message);
    }
  };
  const handleToggle = () => {
    props.handleToggleDetect()
  }
  return (
    <div className=" deliver-location-modal">
      <div className="mt-3">
        {/* <h2 className="mb-3">
                    Delivery Location
                </h2> */}
        <div className="d-flex flex-column flex-lg-row gap-3 gap-lg-0 align-items-lg-center">
          <button
            className="theme-btn border-0"
            onClick={() => {
              showMyLocation();
              props.handleToggleDetect(detectedPincode);
            }}>
            Detect my location
          </button>
          <span className="or-box">
            <span className="or">or</span>
          </span>
          <PlaceSearch apiKey={api_key} />
        </div>
        {JSON.parse(localStorage.getItem("CustomerData")) && (
          <div className="mt-3 ant-modal-title mb-2">Saved Addresses</div>
        )}
        <UserAddresses handleToggleDetect={handleToggle} />
        {/* <AddressGrid address={data?.data} lang={lang} /> */}
      </div>
    </div>
  );
}
